import React, { Component } from "react";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { withStyles } from '@material-ui/core/styles';
import NavigationClose from "@material-ui/icons/Close";
import MenuIcon from '@material-ui/icons/Menu';

import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { pushLeftPanel } from "../actions/dashboard";
import ContentLeftpanel from "../granular/Portal/leftpanel";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

const styles = theme => ({
  appBar: {
    position: 'relative',
    height: "70px"
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
    fontSize: "18px"
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class Leftpanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      left: this.props.leftPanel
    };
  }
  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ left: nextProps.leftPanel });
  }

  handleLeftpanelClose = () => {
    this.props.pushLeftPanel(!this.state.left);
  }

  render() {    
    const { classes } =this.props;
    return (
      <Dialog fullScreen open={this.state.left} onClose={this.handleLeftpanelClose} TransitionComponent={Transition}>
        <AppBar color= "primary" className={classes.appBar}>
          <Toolbar>
            <Typography className={classes.title}>
              Monitoring & Analysis
            </Typography>
            <Button autoFocus color="inherit" onClick={this.handleLeftpanelClose}>
              close
            </Button>
          </Toolbar>
        </AppBar>
        <List>
          <div style={{ width: window.innerWidth + 'px',}}>
            <ContentLeftpanel />
          </div>
        </List>       
      </Dialog>
      // <Drawer
      //   anchor="left"
      //   variant="persistent"
      //   open={this.state.left}
      //   style={{ paper:styles.paper }}
      // >
      //   <AppBar position="static" style={{ background: '#000000' }}>
      //     <Toolbar variant="dense">
      //       <IconButton
      //         edge="start"
      //         color="inherit"
      //         aria-label="Menu"
      //         onClick={this.handleLeftpanelClose}
      //       >
      //         <MenuIcon />
      //       </IconButton>
      //       <Typography color="inherit" styles={{ width: "800" }}>
      //         Monitoring & Analysis
      //       </Typography>
      //     </Toolbar>
      //   </AppBar>
      //   <div style={{ width:"1200px"}}>
      //     <ContentLeftpanel />
      //   </div>
      // </Drawer>
    );
  }
}

Leftpanel.propTypes = {
  classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    leftPanel: state.leftPanel
  };
}

export default withRouter(connect(mapStateToProps, {pushLeftPanel})(withStyles(styles)(Leftpanel)));
